export { default } from "./InfoMessage.tsx";
